"use strict";
/**
 * Permissions module (RBAC-2.3) — ЕДИНСТВЕННЫЙ словарь прав.
 *
 * Четвёртый и последний словарь авторизации переезжает сюда, к трём уже живущим рядом:
 *
 *   | Ось / словарь | Что описывает                     | Где объявлен            |
 *   |---------------|-----------------------------------|-------------------------|
 *   | A             | тир доверия к личности            | `roles/tier.ts`         |
 *   | B             | платформенная должность           | `roles/platform.ts`     |
 *   | C             | членство в магазине + способности | `membership/`           |
 *   | —             | **права** (что имя даёт)          | `permissions/` (здесь)  |
 *
 * Р-1 стори: почему `shared-utils-lib`, а не `shared-auth-lib`, где живёт
 * `requirePermission`.
 *
 * 1. **Один дом у всех словарей.** Это инвариант, ради которого написаны 1.9 и 2.1:
 *    четвёртый дом — это ровно тот дефект, который они убирали. Читающий «какие имена
 *    вообще бывают» должен найти ответ в одном месте.
 * 2. **AD-2.6 исполним только здесь.** Компилятор обязан не пустить способность туда, где
 *    ждут право; утверждение о непересечении можно написать только там, где видны ОБА
 *    словаря. Положи каталог в `shared-auth-lib` — и ей всё равно понадобится
 *    `shared-utils-lib` ради `MerchantCapability`. Вариант «каталог у гейта» не убирает
 *    зависимость, а откладывает её.
 * 3. **Новой зависимости ни у кого не появляется.** [1.9 AC-5](../../..) запрещала вернуть
 *    в `shared-auth-lib` ВТОРОЙ словарь имён — и запрещает по-прежнему. Ребро
 *    `shared-auth-lib → shared-utils-lib` служит обратному: чтобы словарь был один.
 *    Оформлено оно тем же приёмом, что уже отработан на `shared-auth-ui`
 *    (`peerDependencies` + `devDependencies`, без runtime-копии), а `shared-utils-lib`
 *    и так стоит «Full» у всех семи backend-сервисов — то есть в дереве потребителя
 *    пакета не прибавляется, прибавляется объявленное ребро.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./catalog"), exports);
